

export default {
    setArtistHomeMeta(state,data){
        let title='';
        let pic="";
        let url="";
        let keywords="";
        let description="";
        let desc="";
        if(data.hasOwnProperty('meta') &&data.meta){
            title=data.meta.title|| '';
            pic= data.meta.pic || '';
            url= data.meta.url || '';
            description=data.meta.description || '';
            keywords=data.meta.keywords || '';
            desc=data.meta.desc || '';
        }
        state.mate={
            title:title,
            keywords:keywords,
            pic:pic,
            url:url,
            desc:desc,
            description:description,
        };
    },
}
